export const FaqData = [
  {
    question:
      "Lorem Ipsum is simply dummy text of the printing and typesetting ?",
    answer:
      "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum Stet Lorem ipsum dolor sit amet, consetetur sadipscing elitr, diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum Stet.Lorem ipsum dolor sit amet, consetetur sadipscing elitr, diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum Stet.."
  },
  {
    question:
      "Mollit mollit enim excepteur quis et elit esse sit duis ad non aliqua qui?",
    answer:
      "Officia enim id nisi proident excepteur deserunt ea consequat. Cupidatat est in excepteur enim qui nostrud incididunt ex irure amet deserunt elit minim ad. Consequat consequat minim minim id. Labore duis laborum ex aute cillum sit."
  },
  {
    question: "Eiusmod mollit qui nisi ea aute quis?",
    answer:
      "Occaecat ut sunt reprehenderit incididunt. Ad est elit occaecat magna officia exercitation in commodo. Do sit dolore reprehenderit fugiat nisi esse nisi nisi qui consequat deserunt non sunt."
  }
];
